import React, { useEffect } from 'react';

import { useTranslate } from '@/hooks/useTranslate';
import UserStore from '@/store/User';

interface TitleProps {
  title: string;
  showAvatarCount?: boolean;
  extra?: React.ReactNode;
}

const Title: React.FC<TitleProps> = (props) => {
  const { title, showAvatarCount, extra } = props;
  const { t } = useTranslate();

  const { used, total } = UserStore((state) => ({
    used: state.currentVip.avatarSeat.used,
    total: state.currentVip.avatarSeat.total,
  }));

  return (
    <div className="flex justify-between items-center ">
      <div className="flex gap-[8px] items-center">
        <span>{title}</span>
        {showAvatarCount && (
          <span className="bg-[#5661F1] px-[8px] inline-block rounded-[4px] text-[12px] text-[#fff]">
            <span className="font-number">
              {used}/{total}
            </span>
            &nbsp;{t('used')}
          </span>
        )}
      </div>
      {extra}
    </div>
  );
};

export default Title;
